import React from 'react';
import './App.css';
import SignUp from './Components/Pages/SignUp/SignUp';
import SignIn from './Components/Pages/SignIn/SignIn';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import JobListing from './Components/Pages/JobManagement/JobListing/JobListing';
import Dashboard from './Components/Pages/Dashboard/Dashboard';
import CreateJobPosting from './Components/Pages/JobManagement/CreateJobPosting/CreateJobPosting';
import User from './Components/Pages/Admin/User/User';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from './theme';
import ProtectedRoute from './Components/Pages/SignIn/ProtectedRoute';
import DefaultPage from './Components/Pages/DefaultPage';
import Communication from './Components/Pages/Admin/Communication/Communication';
import DashboardMessage from './Components/Pages/Admin/Communication/DashboardMessages/DashboardMessage';
import ManageEmailTemplates from './Components/Pages/Admin/Communication/ManageEmailTemplates/ManageEmailTemplates';
import ChangePassword from './Components/Pages/SignIn/ChangePassword/ChangePassword'; // Import ChangePassword
import ForgetPassword from './Components/Pages/SignIn/ForgetPassword/ForgetPassword';
import AssignTask from './Components/Pages/CandidateManagement/AssignTask/AssignTask';
import CandidatePreboarding from './Components/Pages/Preboarding/CandidatePreboarding/CandidatePreboarding';
import YourOffer from './Components/Pages/Preboarding/CandidatePreboarding/CandidateOffer/CandidateOffer';
import ImportCandidates from './Components/Pages/CandidateManagement/ImportCandidates/ImportProfiles';
import RoleProtectedRoute from './Components/Pages/SignIn/RoleProtectedRoute';
import PersonalDetails from './Components/Pages/Preboarding/CandidatePreboarding/CandidatePersonalDetails.tsx/CandidatePersonalDetails';
import Documents from './Components/Pages/Preboarding/CandidatePreboarding/Documents/Documents';
import ImportNewJob from './Components/Pages/InternalJob/ImportNewJob';
import OTPVerification from './Components/Pages/Preboarding/CandidatePreboarding/OTPVerification/OTPVerification';
import AccessDenied from './Components/Pages/Preboarding/CandidatePreboarding/OTPVerification/AccessDenied';
import ThankYou from './Components/Pages/Preboarding/CandidatePreboarding/OTPVerification/ThankYou';
import CandidateLinkExpired from './Components/Pages/Preboarding/CandidatePreboarding/OTPVerification/CandidateLinkExpired';
import HiringPipeline from './Components/Pages/CandidateManagement/HiringPipeline/HiringPipeline';
import { GlobalProvider } from './Context/GlobalContext';
import ImportProfiles from './Components/Pages/CandidateManagement/ImportCandidates/ImportProfiles';
import PanelStakeholders from './Components/Pages/Admin/PanelAndStakeholders/PanelStakeholders';
import PreboardingConfiguration from './Components/Pages/Admin/PreboardingConfiguration/PreboardingConfiguration';
import OfferLetterSetup from './Components/Pages/Admin/PreboardingConfiguration/OfferLetterSetup';
import DocumentsConfiguration from './Components/Pages/Admin/PreboardingConfiguration/DocumentConfiguration.tsx/DocumentsConfiguration';
import HiringExperienceConfiguration from './Components/Pages/Admin/PreboardingConfiguration/HiringExperienceConfiguration/HiringExperienceConfiguration';
import CandidateDetailsConfiguration from './Components/Pages/Admin/PreboardingConfiguration/CandidateDetailsConfiguration/CandidateDetailsConfiguration';
import Preboarding from './Components/Pages/Preboarding/Preboarding';
import PreboardingSummary from './Components/Pages/Preboarding/PreboardingSummary';
import { PreboardingTabProvider } from './Components/Pages/Preboarding/PreboardingTabProvider';
import AllCandidates from './Components/Pages/Preboarding/AllCandidates';
import HiringExperience from './Components/Pages/Preboarding/CandidatePreboarding/HiringExperience/HiringExperience';
import CandidateOffer from './Components/Pages/Preboarding/CandidatePreboarding/CandidateOffer/CandidateOffer';
import CandidatePersonalDetails from './Components/Pages/Preboarding/CandidatePreboarding/CandidatePersonalDetails.tsx/CandidatePersonalDetails';
import { CandidatePreboardingProvider } from './Components/Pages/Preboarding/CandidatePreboarding/CandidatePreboardingContext';
import SessionExpired from './Components/Pages/Preboarding/CandidatePreboarding/OTPVerification/SessionExpired';
import HiredCandidates from './Components/Pages/Preboarding/HiredCandidates';
import StatusMessage from './Components/Pages/Preboarding/CandidatePreboarding/OTPVerification/StatusMessage';

const router = createBrowserRouter([
  {
    path: "/:tenant/SignUp",
    element: <SignUp />,
  },
  {
    path: "/:tenant",
    element: <SignIn />,
  },
  {
    path: "/:tenant/SignIn",
    element: <SignIn />,
  },
  {
    path: "/:tenant/change-password", // Add this line for ChangePassword
    element: <ChangePassword />,
  },
  {
    path: "/:tenant/forgot-password",
    element: <ForgetPassword />
  },
  {
    path: "/:tenant/OTPVerification",
    element: <OTPVerification />
  },
  {
    path: "/:tenant/SessionExpired",
    element: <SessionExpired />
  },
  {
    path: "/:tenant/AccessDenied",
    element: <AccessDenied />, // The AccessDenied page
  }, 
  {
    path: "/:tenant/ThankYou",
    element: <ThankYou />, // The AccessDenied page
  },
  {
    path: "/:tenant/LinkExpired",
    element: <CandidateLinkExpired />, // The AccessDenied page
  },
  {
    path:"/:tenant/Status",
    element:<StatusMessage/>
  },
  {
    path: "/:tenant/*",
    element: (
      <ProtectedRoute>
        <GlobalProvider>
          <Dashboard />
        </GlobalProvider>
      </ProtectedRoute>
    ),
    children: [
      {
        path: "Joblisting",
        element: <JobListing />,

      },
      // {
      //   path: "/Dashboard",
      //   element: <JobListing />,
      // },
      {
        path: "Joblisting/create-job",
        element: <CreateJobPosting />

      },
      {
        path: "Users",
        element: (
          <RoleProtectedRoute>
            <User />
          </RoleProtectedRoute>
        ),
      },
      {
        path: "PanelStakeholders",
        element: (
          <RoleProtectedRoute>
            <PanelStakeholders />
          </RoleProtectedRoute>
        ),
      },
      {
        path: "preboarding-configuration",
        element: (
          <RoleProtectedRoute>
            <PreboardingConfiguration />
          </RoleProtectedRoute>
        ),
        children: [
          {
            path: "offer-letter",
            element: <OfferLetterSetup />
          },
          {
            path: "candidate-details",
            element: <CandidateDetailsConfiguration />
          },
          {
            path: "documents",
            element: <DocumentsConfiguration />
          },
          {
            path: "hiring-experience",
            element: <HiringExperienceConfiguration />
          }
        ]
      },
      {
        path: "Communication",
        element: (
          <RoleProtectedRoute>
            <Communication />
          </RoleProtectedRoute>
        ),
        children: [
          {
            path: "dashboard-messages",
            element: <DashboardMessage />
          },
          {
            path: "email-templates",
            element: <ManageEmailTemplates />
          },

        ]
      },
      {
        path: "hiringpipeline",
        element: <HiringPipeline />,
      },
      {
        path: "AssignTask",
        element: <AssignTask />,

      },
      {
        path: "ImportProfiles",
        element: <ImportProfiles />,
      },
      {
        path: "preboarding",
        element: (
          <PreboardingTabProvider>
            <Preboarding />
          </PreboardingTabProvider>
        ),
        children: [
          {
            path: "preboarding-summary",
            element: <PreboardingSummary />
          },
          {
            path: "hired-candidates",
            element: <HiredCandidates />
          },
          {
            path: "all-candidates",
            element: <AllCandidates />
          }
        ]
      },
      {
        path: "preboarding/all-candidates/candidate-preboarding", // This should match the path you navigate to
        element: (
          <CandidatePreboardingProvider>
            <CandidatePreboarding />
          </CandidatePreboardingProvider>
        ),
        children: [
          // Add nested routes if needed, e.g.:
          { path: "candidate-offer", element: <CandidateOffer /> },
          { path: "candidate-details", element: <CandidatePersonalDetails /> },
          { path: "documents", element: <Documents /> },
          { path: "hiring-experience", element: <HiringExperience /> },
        ]
      },
      {
        path: "importnewjob",
        element: <ImportNewJob />
      }

    ]
  },
  // You can add more routes here
  {
    path: "/", // Default landing page
    element: <DefaultPage />, // Change to your desired default path
  },
]);


function App() {

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <RouterProvider router={router} />
    </ThemeProvider>
  );
}

export default App;
